import { types, getRoot } from 'mobx-state-tree';
import EditionModel from './editionModel';

const EditionsStore = types.model('EditionsStore', {
    data: types.array(EditionModel),
    selectedID: types.maybeNull(types.string)
}).actions(self => ({
    add(item) {
        self.data.push({ ...item });
    },
    selectEdition(id) {
        self.selectedID = id;
        getRoot(self).factions.selectFaction(null);
        getRoot(self).armies.selectArmy(null);
        getRoot(self).cards.selectCard(null);
    }
})).views(self => ({
    getByGuid(id) {
        return self.data.find(item => item.guidStr === id);
    },
    get selected() {
        return self.data.find(item => item.guidStr === self.selectedID);
    }
}));

export default EditionsStore;
